import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li").eq(1).addClass("active");
var wrapTop = $(".nei-banner").offset().top;
var istrue = true;
$(window).on("scroll",
function() {
    var s = $(window).scrollTop();
    if (s > wrapTop  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})
//设置计数
$.fn.countTo = function (options) {
    options = options || {};
    return $(this).each(function () {
        //当前元素的选项
        var settings = $.extend({}, $.fn.countTo.defaults, {
            from:            $(this).data('from'),
            to:              $(this).data('to'),
            speed:           $(this).data('speed'),
            refreshInterval: $(this).data('refresh-interval'),
            decimals:        $(this).data('decimals')
    }, options);
    //更新值
    var loops = Math.ceil(settings.speed / settings.refreshInterval),
    increment = (settings.to - settings.from) / loops;
    //更改应用和变量
    var self = this,
    $self = $(this),
    loopCount = 0,
    value = settings.from,
    data = $self.data('countTo') || {};
    $self.data('countTo', data);
    //如果有间断，找到并清除
    if (data.interval) {
        clearInterval(data.interval);
    };
    data.interval = setInterval(updateTimer, settings.refreshInterval);
    //初始化起始值
    render(value);
    function updateTimer() {
        value += increment;
        loopCount++;
        render(value);
        if (typeof(settings.onUpdate) == 'function') {
            settings.onUpdate.call(self, value);
        }
        if (loopCount >= loops) {
            //移出间隔
            $self.removeData('countTo');
            clearInterval(data.interval);
            value = settings.to;
            if (typeof(settings.onComplete) == 'function') {
                settings.onComplete.call(self, value);
            }
        }
    }
    function render(value) {
        var formattedValue = settings.formatter.call(self, value, settings);
        $self.html(formattedValue);
    }
    });
};
$.fn.countTo.defaults={
    from:0,               //数字开始的值
    to:0,                 //数字结束的值
    speed:1000,           //设置步长的时间
    refreshInterval:100,  //隔间值
    decimals:0,           //显示小位数
    formatter: formatter, //渲染之前格式化
    onUpdate:null,        //每次更新前的回调方法
    onComplete:null       //完成更新的回调方法
};
function formatter(value, settings){
    return value.toFixed(settings.decimals);
}
//自定义格式
$('#count-number').data('countToOptions',{
    formmatter:function(value, options){
        return value.toFixed(options.decimals).replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
    }
});
//定时器
$('.timer').each(count);
function count(options){
    var $this=$(this);
    options=$.extend({}, options||{}, $this.data('countToOptions')||{});
    $this.countTo(options);
}

// 关于我们
var swiper = new Swiper(".about .swiper", {
    slidesPerView: 4,
    spaceBetween: 22,
    loop:true,
    speed:1000,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".about .swiper-pagination",
        type: "progressbar",
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 2,
        spaceBetween: 10,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 15,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 4,
            spaceBetween: 22,
        }
    },
});


// 荣誉资质
var swiper = new Swiper(".honor .swiper1 .swiper", {
    slidesPerView: 4,
    direction: 'horizontal',
    slidesPerGroup: 4,
    grid: {
        fill: 'row',//column
        rows: 2,
    },
    spaceBetween: 17,
    observer: true,
    observeParents: true,
    pagination: {
        el: '.honor .swiper1 .swiper-pagination',
    },
    navigation: {
        nextEl: '.honor .swiper1 .swiper-button-next',
        prevEl: '.honor .swiper1 .swiper-button-prev',
    },
    breakpoints: {
      320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        grid: {
            fill: 'row',//column
            rows: 1,
        },
      },
      768: { //当屏幕宽度大于等于768 
        slidesPerView: 2,
        spaceBetween: 10,
        slidesPerGroup: 2,
      },
      1280: { //当屏幕宽度大于等于1280
        slidesPerView: 4,
        spaceBetween: 10,
        slidesPerGroup: 4,
      },
      1600: { //当屏幕宽度大于等于1280
        slidesPerView: 4,
        spaceBetween: 17,
        slidesPerGroup: 4,
    }
  },
});
var swiper = new Swiper(".honor .swiper2 .swiper", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    direction: 'horizontal',
    grid: {
        fill: 'row',//column
        rows: 2,
    },
    spaceBetween: 17,
    observer: true,
    observeParents: true,
    pagination: {
        el: '.honor .swiper2 .swiper-pagination',
    },
    navigation: {
        nextEl: '.honor .swiper2 .swiper-button-next',
        prevEl: '.honor .swiper2 .swiper-button-prev',
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
          grid: {
              fill: 'row',//column
              rows: 1,
          },
        },
        768: { //当屏幕宽度大于等于768 
          slidesPerView: 2,
          spaceBetween: 10,
          slidesPerGroup: 2,
        },
        1280: { //当屏幕宽度大于等于1280
          slidesPerView: 4,
          spaceBetween: 10,
          slidesPerGroup: 4,
        },
        1600: { //当屏幕宽度大于等于1280
          slidesPerView: 4,
          spaceBetween: 17,
          slidesPerGroup: 4,
      }
    },
});
var swiper = new Swiper(".honor .swiper3 .swiper", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    direction: 'horizontal',
    grid: {
        fill: 'row',//column
        rows: 2,
    },
    spaceBetween: 17,
    observer: true,
    observeParents: true,
    pagination: {
        el: '.honor .swiper3 .swiper-pagination',
    },
    navigation: {
        nextEl: '.honor .swiper3 .swiper-button-next',
        prevEl: '.honor .swiper3 .swiper-button-prev',
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
          grid: {
              fill: 'row',//column
              rows: 1,
          },
        },
        768: { //当屏幕宽度大于等于768 
          slidesPerView: 2,
          spaceBetween: 10,
          slidesPerGroup: 2,
        },
        1280: { //当屏幕宽度大于等于1280
          slidesPerView: 4,
          spaceBetween: 10,
          slidesPerGroup: 4,
        },
        1600: { //当屏幕宽度大于等于1280
          slidesPerView: 4,
          spaceBetween: 17,
          slidesPerGroup: 4,
        }
    },
});
$(".honor .honor-text li").eq(0).addClass("active");
$(".honor .honor-list li").eq(0).addClass("active");
$(".honor .swiper-list .swiper-box").eq(0).addClass("active");
$(".honor .honor-list li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".honor .honor-text li").eq(index).addClass("active").siblings().removeClass("active");
    $(".honor .swiper-list .swiper-box").eq(index).addClass("active").siblings().removeClass("active");
})

// 子公司布局
var subsidiary = new Swiper(".subsidiary .mySwiper", {
    slidesPerView: 4,
    spaceBetween: 24,
    loop:true,
    speed:500,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 4,
            spaceBetween: 24,
        }
    },
    navigation: {
      nextEl: ".subsidiary .swiper-button-next",
      prevEl: ".subsidiary .swiper-button-prev",
    },
    pagination: {
        el: '.subsidiary .swiper-pagination',
        // 是否可点击----必填项
        clickable: true,
      },
});

// 企业文化
$(".culture-pic .pic").eq(0).addClass("active");
$(".culture-nav li").eq(0).addClass("active");
$(".culture-nav li").hover(function () {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".culture-pic .pic").eq(index).addClass("active").siblings().removeClass("active");
})
var subsidiary = new Swiper(".culture .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    loop:true,
    speed:1000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
});

// 社会责任
var swiper = new Swiper(".social .swiper1 .swiper", {
    navigation: {
      nextEl: ".social .swiper1 .swiper-button-next",
      prevEl: ".social .swiper1 .swiper-button-prev",
    },
});
$(".social ul li").eq(0).addClass("active");
$(".social .swiper-list .swiper-box").eq(0).addClass("active");
$(".social ul li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".social .swiper-list .swiper-box").eq(index).addClass("active").siblings().removeClass("active");
})